export function calculateTimeDifference(firstDate, secondDate) {
    let date1 = new Date(firstDate);
    let date2 = new Date(secondDate);
    let difference = date2 - date1;
    return difference;
}

export function formatTimeInSecondsToMMSS(time) {
    if (isNaN(time)) {
        return '00:00';
    }

    let secNum = parseInt(time, 10);
    if (secNum < 0) {
        secNum = 0;
    }
    let hours = Math.floor(secNum / 3600);
    let minutes = Math.floor((secNum - (hours * 3600)) / 60);
    let seconds = secNum - (hours * 3600) - (minutes * 60);
    return formatTwoDigits(minutes) + ':' + formatTwoDigits(seconds);
}

export function formatTimeToHHMM(time) {
    let d = new Date(time);
    let hours = formatTwoDigits(d.getHours());
    let minutes = formatTwoDigits(d.getMinutes());
    return hours + ':' + minutes;
}

export function formatTwoDigits(n) {
    return n < 10
        ? '0' + n
        : n;
}

export function formatTimeToShow(time, systemLanguage, options = {month: 'short', day: 'numeric'}) {
    let d = new Date(time);
    let hoursMinutes = formatTimeToHHMM(time);

    //let options = {month: 'short', day: 'numeric'};
    let dayMonthYear = d.toLocaleDateString(systemLanguage.replace("_", "-"), options);
    return {
        dayMonthYear: dayMonthYear,
        hoursMinutes: hoursMinutes
    };
}

export function formatTimeInSecondsToS(time) {
    if (isNaN(time)) {
        return '0';
    }

    let secNum = parseInt(time, 10);
    if (secNum < 0) {
        secNum = 0;
    }
    let hours = Math.floor(secNum / 3600);
    let minutes = Math.floor((secNum - (hours * 3600)) / 60);
    let seconds = secNum - (hours * 3600) - (minutes * 60);
    return seconds;
}

export function betSlipAnimationCalculate(isQuickBet, reference) {
    let source = reference ? reference.getBoundingClientRect() : '';
    let toElement = document.getElementById('bet_slip_accordion') && !document.getElementById('bet_slip_counter')
        ? document.getElementById('open_bets_tab')
            ? document.getElementById('open_bets_tab')
            : document.getElementById('bet_slip_accordion')
        : document.getElementById('bet_slip_counter');
    let target = toElement.getBoundingClientRect();
    let sourceTop, sourceLeft, targetTop, targetLeft;

    if (isQuickBet) {
        let videoIframePosition = document.getElementById('video-iframe').getBoundingClientRect();
        sourceTop = source.top - videoIframePosition.top;
        sourceLeft = source.left - videoIframePosition.left;
        targetTop = target.top - videoIframePosition.top;
        targetLeft = target.left - videoIframePosition.left;
    } else {
        sourceTop = source.top;
        sourceLeft = source.left;
        targetTop = target.top;
        targetLeft = target.left;
    }

    document.documentElement.style.setProperty('--betSlipAnimationToTop', `${targetTop}px`);
    document.documentElement.style.setProperty('--betSlipAnimationToLeft', `${targetLeft}px`);

    return {sourceTop, sourceLeft};
}



// WEBPACK FOOTER //
// ./src/helpers/helperFunctions.js